import script from "./TodoManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoManagement.vue?vue&type=script&setup=true&lang=js"

import "./TodoManagement.vue?vue&type=style&index=0&id=2c6cd18f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6cd18f"]])

export default __exports__